/** Campi timer ridondanti — compatibilità Android (Gson @SerializedName alternate). */
export type EphemeralTimerFields = {
  isEphemeral: true
  ttl: number
  ttlMs: number
  ephemeralTimer: number
  disappearingTimer: number
  selfDestructTimer: number
  durationMs: number
}

function positiveNumber(value: unknown): number | undefined {
  const n = Number(value)
  if (!Number.isFinite(n) || n <= 0) return undefined
  return n
}

/** Costruisce ttl (secondi) + ttlMs e alias per il parser Android. */
export function buildEphemeralTimerFields(durationMs: number): EphemeralTimerFields {
  const raw = Number(durationMs)
  const ms = Math.max(1_000, Math.round(Number.isFinite(raw) ? raw : 86_400_000))
  const sec = Math.max(1, Math.round(ms / 1000))
  return {
    isEphemeral: true,
    ttl: sec,
    ttlMs: sec * 1000,
    ephemeralTimer: sec,
    disappearingTimer: sec,
    selfDestructTimer: sec,
    durationMs: ms,
  }
}

/**
 * Legge durata da evento socket / envelope Android.
 * Supporta ttl, ephemeralTimer, ttlMs, durationMs (ms o secondi se > 100_000).
 */
export function resolveDurationMsFromPayload(data: Record<string, unknown>): number | undefined {
  const directMs = positiveNumber(data.ttlMs) ?? positiveNumber(data.durationMs)
  if (directMs != null) return Math.round(directMs)

  const ttlRaw =
    positiveNumber(data.ttl) ??
    positiveNumber(data.ephemeralTimer) ??
    positiveNumber(data.disappearingTimer) ??
    positiveNumber(data.selfDestructTimer)

  if (ttlRaw == null) return undefined
  if (ttlRaw > 100_000) return Math.round(ttlRaw)
  return Math.round(ttlRaw * 1000)
}

export function ephemeralFieldsFromExpiresAt(expiresAt: number, now = Date.now()): EphemeralTimerFields {
  const remaining = Math.max(60_000, Math.round(expiresAt - now))
  return buildEphemeralTimerFields(remaining)
}
